import { useState, useEffect } from "react";
import HeaderBar from "./HeaderBar/HeaderBar";
import InfoPanel from "./InfoPanel";
import Login from "./Login/Login";
import HiTrustLogo from "../../assets/images/HITRUSTCSFCertifiedLogo_white.png";
import PoweredByAWS from "../../assets/images/poweredby-aws.png";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const Home = () => {
  const currentYear = new Date().getFullYear();
  const [domainBox, setDomainBox] = useState(null);

  useEffect(() => {
    const initializeHome = async () => {
      try {
        const customHome = await import(
          "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/home/home"
        );

        const { Home } = await customHome;
        setDomainBox(<Home />);
      } catch {
        setDomainBox(DefaultBox);
      }
    };
    initializeHome();
  }, []);

  const DefaultBox = (
    <div>
      <HeaderBar />
      <div id="sesMainContentWrapper" className="animate slide delay-4">
        <Login />
        <article>
          {/*<section className="alert alert-warning sp-mx4 shade-3 dg-clr">*/}
          {/*    <b>SCHEDULED MAINTENANCE:</b> On [ Friday, May 30th at 9pm ] we will perform maintenance that will cause the portal and webmail application to be unavailable for approximately [ 4 ] hours. If you have any questions regarding this maintenance, please contact support.*/}
          {/*</section>*/}
          <section className="ses-text-container">
            <div className="main-whyhow-text animate slide delay-5">
              <div className="main-whyhow-title">Why Direct?</div>
              <hr />
              <p>
                Direct Mail provides healthcare professionals the ability to
                communicate securely with their colleagues and patients. We
                enable healthcare professionals to maintain HIPAA compliance
                when sending and receiving encrypted health information over
                email.
              </p>
              We work with physicians to ensure that our product is
              user-friendly and fits easily into your current workflow. Our
              exclusive technology integrates seamlessly with any EHR, patient
              management and email system, allowing you to start communicating
              immediately.
            </div>
          </section>
          <section className="ses-news-container">
            <div className="news-content animate slide delay-6">
              <div className="news-header">What we do...</div>
              <hr />
              <p>
                The ability to communicate electronically with patients, labs,
                hospitals and other providers is crucial for patient
                satisfaction and quality of care. The functionality provided by
                this technology is key to simple, secure communications that
                work within your existing workflow. Our solution provides a
                secure way for healthcare professionals to send and receive
                encrypted health information over the Internet.
              </p>
              {/* Change for Custom Branding */}
              <h2 className="sp-margin10">Technical Support</h2>
              Phone: 888-470-9913
              <br />
              {/* Fax: 865-481-0921<br /> */}
              Email:{" "}
              <a
                href="mailto:support@secureexsolutions.com"
                title="Email Support"
              >
                {" "}
                support@secureexsolutions.com{" "}
              </a>
            </div>
          </section>
        </article>
      </div>
      <InfoPanel />
      <div className="ses_footer">
        <div className="ses-footer animate slide delay-2">
          <footer>
            <div className="ses-footer-container">
              <div
                className="ses-directTrust"
                title="Direct Trust Certification DTAAP HISP DTAAP CA DTAAP RA"
              ></div>
              {/*<div className="ses-drummond" title="Drummond Certification"></div>*/}
            </div>
            <div className="right-container">
              <div className="poweredby-aws">
                <a
                  href="http://hitrustalliance.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={HiTrustLogo}
                    className="hitrust-img"
                    alt="HITRUST logo"
                    title="HITRUST Logo"
                  />
                </a>
                {/*<a href="http://hitrustalliance.net" target="_blank"><img src={ HiTrustLogo } className="hitrust-img" alt="HITRUST logo" title="HITRUST Logo" /></a>*/}
                <img
                  src={PoweredByAWS}
                  alt="aws powered by logo"
                  title="Powered by AWS"
                />
              </div>
              <div className="contact-footer">
                <b>Technical Support:</b> 1.888.470.9913 |{" "}
                <a href="mailto:support@secureexsolutions.com">
                  {" "}
                  support@secureexsolutions.com{" "}
                </a>
              </div>
              <div className="copyright">
                For more information about our ONC certification please visit
                <a
                  href="http://www.secureexsolutions.com/ONC"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  secureexsolutions.com/ONC{" "}
                </a>
                <br />
                Copyright &copy; {currentYear} |{" "}
                <a
                  href="http://secureexsolutions.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  Secure Exchange Solutions{" "}
                </a>{" "}
                | Powered by SES Direct |{" "}
                <a
                  href="http://www.secureexsolutions.com/privacy-policy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy and Terms of Use
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );

  return <div>{domainBox}</div>;
};

export default Home;
